import { Component, inject } from '@angular/core';
import { DebugService } from '../../../service/debug.service';
import { UserLoginService } from '../../../service/user-login.service';
import { AuthableRole } from '../../../types';

@Component({
  selector: 'app-debug-panel',
  templateUrl: './debug-panel.component.html',
  styleUrls: ['./debug-panel.component.scss'],
  standalone: false,
})
export class DebugPanelComponent {
  public debug = inject(DebugService);
  public userService = inject(UserLoginService);

  public readonly toggleableRoles: Array<AuthableRole | 'none'> = [
    'none',
    'admin',
    'validator',
    'investigator',
    'branch-owner',
    'branch-manager',
    'market-manager',
    'installer',
    'self-service',
    'self-service-investigator',
  ];

  public setRole(role: AuthableRole | 'none', event: Event) {
    this.debug.setRole(role, (event.target as HTMLInputElement).checked);
  }

  setMyRoles() {
    this.debug.resetRoles();

    this.userService.currentProfileRoleList().forEach((role) => {
      this.debug.setRole(role, true);
    });
  }
}
